import { ButtonHTMLAttributes, FC, forwardRef } from 'react';
import { ColorProps, Colors, ColorsDictionary, Variants } from '../../types/ui';

const ButtonFilledColors: Readonly<ColorsDictionary> = {
    // [Colors.Primary]: 'bg-blue-500 border-blue-300 text-gray-100',
    [Colors.Primary]: 'bg-purple-500 border-purple-300 text-gray-100',
    [Colors.Info]: 'bg-blue-500 border-blue-300 text-gray-100',
    [Colors.Secondary]: 'bg-gray-500 border-gray-300 text-gray-100',
    [Colors.Dark]: 'bg-gray-500 border-gray-400 text-gray-100',
    [Colors.Warning]: 'bg-yellow-500 border-yellow-300 text-gray-100',
    [Colors.Danger]: 'bg-red-500 border-red-300 text-gray-100',
    [Colors.Success]: 'bg-green-500 border-green-300 text-gray-100',
};

const ButtonOutlineColors: Readonly<ColorsDictionary> = {
    // [Colors.Primary]: 'bg-transparent border-2 border-blue-500 text-blue-500 hover:bg-blue-500 focus:border-blue-300 hover:text-gray-100',
    [Colors.Primary]: 'bg-transparent border-2 border-purple-500 text-purple-500 hover:bg-purple-500 focus:border-purple-300 hover:text-gray-100',
    [Colors.Info]: 'bg-transparent border-2 border-blue-500 text-blue-500 hover:bg-blue-500 focus:border-blue-300 hover:text-gray-100',
    [Colors.Secondary]: 'bg-transparent border-2 border-gray-500 text-gray-500 hover:bg-gray-500 focus:border-gray-300 hover:text-gray-100',
    [Colors.Dark]: 'bg-transparent border-2 border-gray-500 text-gray-500 hover:bg-gray-500 focus:border-gray-300 hover:text-gray-100',
    [Colors.Warning]: 'bg-transparent border-2 border-yellow-500 text-yellow-500 hover:bg-yellow-500 focus:border-yellow-300 hover:text-gray-100',
    [Colors.Danger]: 'bg-transparent border-2 border-red-500 text-red-500 hover:bg-red-500 focus:border-red-300 hover:text-gray-100',
    [Colors.Success]: 'bg-transparent border-2 border-green-500 text-green-500 hover:bg-green-500 focus:border-green-300 hover:text-gray-100',
};

const ButtonSize = 'p-2 pl-5 pr-5';

const TextSize = 'text-lg';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & ColorProps;

const Button: FC<ButtonProps> =
    forwardRef<HTMLButtonElement, ButtonProps>(({
                                                    children,
                                                    color,
                                                    variant = Variants.Filled,
                                                    ...rest
                                                }: ButtonProps, ref) => {
        return (
            <button
                ref={ref}
                className={[
                    'rounded-lg focus:border-4 disabled:opacity-50 disabled:pointer-events-none',
                    ButtonSize,
                    TextSize,
                    Variants.Outline === variant ? ButtonOutlineColors[color] : ButtonFilledColors[color]
                ].join(' ')}
                type="button"
                {...rest}
            >
                {children}
            </button>
        );
    });

Button.displayName = 'Button';

export default Button;